export class CookieHelper {
  static get(name: string) {
    const cookieValue = document.cookie
      .split('; ')
      .find(row => row?.toLowerCase().startsWith(name?.toLowerCase()))
      ?.split('=')[1];
    return cookieValue;
  }

  static getBool(name: string): boolean {
    const cookieValue = this.get(name);
    const value = cookieValue?.toLowerCase() == 'true';
    return value;
  }
}
